<template>
  <div
    :style="loaderStyles"
    class="circle-loader"></div>
</template>

<script>
  export default {
    name: "CircleLoader",
    props: {
      diameter: {
        type: Number,
        default: 18,
      },
    },
    computed: {
      loaderStyles() {
        const d = this.diameter;
        return {
          height: `${d}px`,
          width: `${d}px`
        }
      }
    }
  }
</script>

<style lang="scss">
  .circle-loader {
    display: block;
    border-radius: 50%;
    -webkit-animation: spin1 1s infinite linear;
    animation: spin1 1s infinite linear;
    border: 4px solid #eee;
    border-top: 4px solid #aaa;
    border-bottom: 4px solid #aaa;
    &.md-success {
      border: 4px solid #4caf50e0;
      border-top: 4px solid #4caf504d;
      border-bottom: 4px solid #4caf504d;
    }
  }

  @-webkit-keyframes spin1 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
  @keyframes spin1 {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
</style>
